import {useCookies} from 'vue3-cookies'
import {decodeBase64, encodeBase64} from './utils'

const USER_PROPERTIES_KEY = 'userProperties'

interface UserProperties {
  id: number
  username: string
  roles: string[]
}

class UserPropertiesCookie {
  get(): UserProperties | undefined {
    const cookies = useCookies().cookies
    const cookieString = cookies.get(USER_PROPERTIES_KEY)
    return cookieString ? decodeBase64(cookieString) : undefined
  }

  isSet() {
    const cookies = useCookies().cookies
    return cookies.isKey(USER_PROPERTIES_KEY)
  }

  remove() {
    const {cookies} = useCookies()
    cookies.remove(USER_PROPERTIES_KEY)
  }

  set(id: number, username: string, roles: string[]) {
    const {cookies} = useCookies()
    const userProperties: UserProperties = {
      id: id,
      username: username,
      roles: roles,
    }

    cookies.set(USER_PROPERTIES_KEY, encodeBase64(userProperties))
  }
}

export default new UserPropertiesCookie()
